import { cricket, diageo, influencemobile } from 'routes/subdomains';
import Footer from 'components/Footer';
import './styles.scss';

type IProps = {
  type: string;
};

function CustomFooter({ type }: IProps) {
  let footerContent;

  // Determine footer content based on the subdomain type
  switch (type) {
    case influencemobile:
      // Render the default Footer component for the 'influencemobile' subdomain
      footerContent = <Footer />;
      break;
    case cricket:
      // Render a custom footer message specifically for the 'cricket' subdomain
      footerContent = (
        <div className="cricketfooter">
          <div className="footermodule py-5">
            <div className="container">
              <div className="row">
                <div className="col-md-10 col-sm-10 col-12 offset-md-1 offset-sm-1">
                  <ul className="footermenu" role="navigation" aria-label="Footer navigation">
                    <li>
                      <a
                        target="_blank"
                        aria-label="Frequently Asked Questions (opens in a new tab)"
                        href="https://sweeps.cricketwireless.com/faq"
                      >
                        FAQ
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        aria-label="Official Rules (opens in a new tab)"
                        href="https://sweeps.cricketwireless.com/rules"
                      >
                        Official Rules
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        aria-label="Privacy Policy (opens in a new tab)"
                        href="https://www.cricketwireless.com/privacy"
                      >
                        Privacy Policy
                      </a>
                    </li>
                  </ul>
                  <p>
                    <strong>NO PURCHASE NECESSARY</strong>. Open from{' '}
                    <strong>November 20, 2024, at 12:00:01 AM ET – January 9, 2025, at 11:59:59 PM ET</strong>. USA only and age
                    of majority or older in your state of residence. Void where prohibited. Sponsored by Cricket Wireless LLC.
                    Must be a member of Cricket Wireless in good standing.  Must complete entry registration form on{' '}
                    <a
                      target="_blank"
                      aria-label="Entry registration form URL (opens in a new tab)"
                      href="https://sweeps.cricketwireless.com"
                    >
                      https://sweeps.cricketwireless.com.
                    </a>{' '}
                    Limit one entry per person, per phone number. Limit one (1) Prize per person. No cash value or substitutions.
                    15,195 winners will be chosen. Odds of winning are dependent on number of entries. Winners must accept the
                    Official Rules. Full Official Rules apply at{' '}
                    <a
                      target="_blank"
                      aria-label="Full Official URL (opens in a new tab)"
                      href="https://sweeps.cricketwireless.com/rules"
                    >
                      https//sweeps.cricketwireless.com/rules.
                    </a>{' '}
                    Void where prohibited.
                  </p>
                  <p>
                    <a
                      aria-label="Not Sell or Share my Personal Information (opens in a new tab)"
                      target="_blank"
                      href="https://www.cricketwireless.com/legal-info/california-consumer-privacy-act.html"
                    >
                      Do Not Sell or Share my Personal Information
                    </a>
                  </p>
                  <p>
                    <a
                      aria-label="Limit the Use of my Sensitive Personal Information (opens in a new tab)"
                      target="_blank"
                      href="https://www.cricketwireless.com/legal-info/california-consumer-privacy-act.html"
                    >
                      Limit the Use of my Sensitive Personal Information
                    </a>
                  </p>
                  <ul className="socialicon">
                    <li>
                      <a
                        target="_blank"
                        href="https://www.facebook.com/cricketwireless"
                        rel="noopener noreferrer"
                        aria-label="facebook icon (opens in a new tab)"
                      >
                        <span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="29"
                            height="28"
                            viewBox="0 0 29 28"
                            fill="none"
                            aria-label="facebook icon"
                            role="img"
                          >
                            <title>facebook icon</title>
                            <path
                              d="M21.7301 0H7.82215C3.98157 0 0.868164 3.11341 0.868164 6.95399V20.862C0.868164 24.7025 3.98157 27.8159 7.82215 27.8159H21.7301C25.5707 27.8159 28.6841 24.7025 28.6841 20.862V6.95399C28.6841 3.11341 25.5707 0 21.7301 0Z"
                              fill="white"
                            ></path>
                            <path
                              d="M20.1899 17.9283L20.8066 13.908H16.9492V11.3002C16.9492 10.2001 17.4871 9.12711 19.2147 9.12711H20.9695V5.70445C20.9695 5.70445 19.3778 5.4328 17.8566 5.4328C14.6784 5.4328 12.603 7.35873 12.603 10.8439V13.908H9.07169V17.9283H12.603V27.6475C13.312 27.7589 14.0372 27.8159 14.7761 27.8159C15.5149 27.8159 16.2402 27.7589 16.9492 27.6475V17.9283H20.1899Z"
                              fill="#404041"
                            ></path>
                          </svg>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        href="https://twitter.com/CricketNation"
                        rel="noopener noreferrer"
                        aria-label="x social media icon (opens in a new tab)"
                      >
                        <span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="29"
                            height="28"
                            viewBox="0 0 29 28"
                            fill="none"
                            aria-label="x social media icon"
                            role="img"
                          >
                            <title>x social media icon</title>
                            <path
                              d="M21.5456 0H7.63758C3.797 0 0.683594 3.11341 0.683594 6.95399V20.862C0.683594 24.7025 3.797 27.8159 7.63758 27.8159H21.5456C25.3861 27.8159 28.4995 24.7025 28.4995 20.862V6.95399C28.4995 3.11341 25.3861 0 21.5456 0Z"
                              fill="white"
                            ></path>
                            <path
                              d="M16.3558 12.4881L23.2592 4.63599H21.6233L15.6291 11.4539L10.8415 4.63599H5.31959L12.5593 14.9459L5.31959 23.18H6.95556L13.2856 15.98L18.3417 23.18H23.8635L16.3558 12.4881ZM7.54503 5.84105H10.0578L21.6241 22.0296H19.1113L7.54503 5.84105Z"
                              fill="#404041"
                            ></path>
                          </svg>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        href="https://www.instagram.com/accounts/login/?next=https%3A%2F%2Fwww.instagram.com%2Fcricketwireless%2F&amp;is_from_rle"
                        rel="noopener noreferrer"
                        aria-label="instagram icon (opens in a new tab)"
                      >
                        <span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="29"
                            height="28"
                            viewBox="0 0 29 28"
                            fill="none"
                            aria-label="A black and white icon of an instagram camera on a white background"
                            role="img"
                          >
                            <title>A black and white icon of an instagram camera on a white background</title>
                            <path
                              d="M7.5534 27.7175C5.89917 27.6423 5.00056 27.3671 4.40285 27.1339C3.61087 26.8256 3.04623 26.4585 2.45184 25.8649C1.85743 25.2714 1.48956 24.7067 1.18285 23.9148C0.949719 23.3171 0.674434 22.4184 0.599204 20.7643C0.516534 18.976 0.5 18.4395 0.5 13.9092C0.5 9.3789 0.518187 8.8432 0.598377 7.05339C0.673606 5.39917 0.950554 4.50221 1.18203 3.90284C1.49038 3.11087 1.85827 2.54624 2.45102 1.95101C3.04458 1.35744 3.60921 0.988732 4.40203 0.682027C4.99972 0.448897 5.89835 0.173606 7.55258 0.0983772C9.34155 0.016534 9.87891 0 14.4076 0C18.9379 0 19.4736 0.0181873 21.2634 0.0983772C22.9177 0.173606 23.8146 0.450551 24.4139 0.682027C25.2059 0.988732 25.7705 1.35744 26.365 1.95101C26.9593 2.54458 27.3256 3.11004 27.634 3.90202C27.867 4.49973 28.1423 5.39834 28.2175 7.05257C28.2995 8.84238 28.3159 9.37808 28.3159 13.9084C28.3159 18.437 28.2995 18.9744 28.2175 20.7643C28.1423 22.4184 27.8654 23.3171 27.634 23.9148C27.3256 24.7067 26.9585 25.2714 26.365 25.8649C25.7713 26.4585 25.2059 26.8256 24.4139 27.1339C23.8162 27.3671 22.9177 27.6423 21.2634 27.7175C19.4752 27.7994 18.9379 27.8159 14.4076 27.8159C9.87891 27.8159 9.34155 27.8003 7.5534 27.7175Z"
                              fill="white"
                            ></path>
                            <path
                              d="M11.2521 13.8095C11.2521 12.1207 12.6208 10.7514 14.3094 10.7514C15.9982 10.7514 17.3676 12.1207 17.3676 13.8095C17.3676 15.4982 15.9982 16.8675 14.3094 16.8675C12.6208 16.8675 11.2521 15.4982 11.2521 13.8095ZM9.599 13.8095C9.599 16.4111 11.7078 18.52 14.3094 18.52C16.911 18.52 19.0199 16.4111 19.0199 13.8095C19.0199 11.2079 16.911 9.09899 14.3094 9.09899C11.7078 9.09899 9.599 11.2077 9.599 13.8095ZM18.1056 8.91222C18.1056 9.12995 18.1701 9.3428 18.2909 9.52388C18.4118 9.70495 18.5837 9.84611 18.7848 9.92952C18.9859 10.0129 19.2072 10.0348 19.4208 9.99241C19.6343 9.95002 19.8305 9.84526 19.9846 9.69136C20.1386 9.53747 20.2435 9.34137 20.286 9.12785C20.3286 8.91433 20.3069 8.69298 20.2237 8.4918C20.1405 8.29062 19.9994 8.11864 19.8184 7.99761C19.6375 7.87658 19.4247 7.81193 19.2069 7.81184C18.9151 7.81198 18.6348 7.92794 18.4284 8.13426C18.222 8.34058 18.106 8.62038 18.1056 8.91222ZM10.6034 21.2765C9.70901 21.2357 9.22288 21.0868 8.89983 20.9609C8.47153 20.7942 8.16595 20.5956 7.84466 20.2748C7.52337 19.9539 7.32449 19.6486 7.15848 19.2204C7.03255 18.8975 6.88358 18.4111 6.84292 17.5167C6.79844 16.5498 6.78956 16.2593 6.78956 13.8096C6.78956 11.3598 6.79918 11.0702 6.84292 10.1024C6.88365 9.20805 7.03373 8.72273 7.15848 8.39887C7.32522 7.97058 7.52381 7.665 7.84466 7.3437C8.16551 7.02241 8.4708 6.82353 8.89983 6.65753C9.22274 6.5316 9.70901 6.38262 10.6034 6.34197C11.5704 6.29748 11.8608 6.28861 14.3094 6.28861C16.7582 6.28861 17.0488 6.29807 18.0166 6.3421C18.911 6.38284 19.3964 6.53292 19.7202 6.65768C20.1485 6.82368 20.4541 7.023 20.7754 7.34385C21.0966 7.66471 21.2948 7.97073 21.4615 8.39902C21.5875 8.72192 21.7364 9.20819 21.7771 10.1026C21.8216 11.0703 21.8304 11.36 21.8304 13.8098C21.8304 16.2595 21.8216 16.5492 21.7771 17.517C21.7364 18.4113 21.5867 18.8975 21.4615 19.2205C21.2948 19.6487 21.0962 19.9543 20.7754 20.2749C20.4546 20.5955 20.1485 20.7944 19.7202 20.9611C19.3973 21.087 18.911 21.236 18.0166 21.2766C17.0496 21.3212 16.7592 21.33 14.3094 21.33C11.8597 21.33 11.57 21.321 10.6034 21.2765ZM10.5274 4.69154C9.55085 4.73602 8.88354 4.89087 8.30077 5.11764C7.69759 5.35181 7.1863 5.66599 6.67574 6.17574C6.16519 6.68549 5.85182 7.19685 5.61764 7.80076C5.39087 8.3839 5.23602 9.05085 5.19155 10.0274C5.14633 11.0055 5.136 11.3182 5.136 13.8095C5.136 16.3007 5.14633 16.6134 5.19155 17.5915C5.23602 18.5682 5.39087 19.235 5.61764 19.8182C5.85182 20.4213 6.16526 20.9337 6.67574 21.4432C7.18623 21.9527 7.69686 22.2664 8.30077 22.5012C8.88464 22.7281 9.55085 22.8829 10.5274 22.9274C11.506 22.9718 11.8183 22.9829 14.3094 22.9829C16.8007 22.9829 17.1134 22.9726 18.0915 22.9274C19.0682 22.8829 19.735 22.7281 20.3181 22.5012C20.9213 22.2664 21.4326 21.9529 21.9432 21.4432C22.4537 20.9335 22.7664 20.4213 23.0013 19.8182C23.228 19.235 23.3837 18.5681 23.4274 17.5915C23.4719 16.6126 23.4822 16.3007 23.4822 13.8095C23.4822 11.3182 23.4719 11.0055 23.4274 10.0274C23.3829 9.05078 23.228 8.38354 23.0013 7.80076C22.7664 7.19758 22.4529 6.68629 21.9432 6.17574C21.4334 5.66518 20.9213 5.35181 20.3188 5.11764C19.735 4.89087 19.068 4.73528 18.0923 4.69154C17.114 4.64685 16.8014 4.63599 14.3106 4.63599C11.8197 4.63599 11.506 4.64634 10.5274 4.69154Z"
                              fill="#404041"
                            ></path>
                          </svg>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        href="https://www.youtube.com/user/CricketNation"
                        rel="noopener noreferrer"
                        aria-label="youtube icon (opens in a new tab)"
                      >
                        <span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="29"
                            height="28"
                            viewBox="0 0 29 28"
                            fill="none"
                            aria-label="youtube icon"
                            role="img"
                          >
                            <title>youtube icon</title>
                            <path
                              d="M21.1784 0H7.27039C3.42981 0 0.316406 3.11341 0.316406 6.95399V20.862C0.316406 24.7025 3.42981 27.8159 7.27039 27.8159H21.1784C25.0189 27.8159 28.1324 24.7025 28.1324 20.862V6.95399C28.1324 3.11341 25.0189 0 21.1784 0Z"
                              fill="white"
                            ></path>
                            <path
                              d="M22.3238 9.92648C22.1329 9.21744 21.5738 8.6584 20.8647 8.4675C19.5694 8.11298 14.388 8.11298 14.388 8.11298C14.388 8.11298 9.2066 8.11298 7.91125 8.45387C7.21585 8.64475 6.64317 9.21744 6.45227 9.92648C6.1114 11.2218 6.1114 13.908 6.1114 13.908C6.1114 13.908 6.1114 16.6077 6.45227 17.8895C6.64317 18.5986 7.20221 19.1575 7.91125 19.3484C9.22024 19.703 14.388 19.703 14.388 19.703C14.388 19.703 19.5694 19.703 20.8647 19.3621C21.5738 19.1712 22.1329 18.6121 22.3238 17.9032C22.6646 16.6077 22.6646 13.9216 22.6646 13.9216C22.6646 13.9216 22.6782 11.2218 22.3238 9.92648Z"
                              fill="#404041"
                            ></path>
                            <path d="M12.738 16.3895L17.0467 13.9079L12.738 11.4263V16.3895Z" fill="white"></path>
                          </svg>
                        </span>
                      </a>
                    </li>
                  </ul>

                  <p className="copyright">© 2024 Cricket Wireless LLC. All rights reserved.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
      break;
    case diageo:
      // No footer displayed for the 'diageo' subdomain
      footerContent = null;
      break;
    default:
      // Default to no footer if the subdomain does not match any specified cases
      footerContent = null;
  }

  // Render the selected footer content based on the type
  return <div>{footerContent}</div>;
}

export default CustomFooter;
